export enum TimeNotation {
  Correct = '24hour',
  Wrong = '12hour'
}
